<ui-registered-footer appName="Patient" browserTarget="{{ browserTarget }}"></ui-registered-footer>
